module.exports = __webpack_public_path__ + "media/images/icons/ic-map-f83a114d4cf36391022afb52088d053b.svg";